import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import {
  listarClavesSatClavesCuenta,
  type ListarClavesSatClavesCuentaParams,
} from "../services/clave-sat-clave-cuenta-service";

/**
 * Listado PAGINADO server-side · query options compartidas entre el loader del
 * route y el componente. La key extiende `qk.adminClavesSatClavesCuenta` para que
 * los invalidate de las mutations sigan alcanzando por prefijo.
 */
export const clavesSatClavesCuentaQueryOptions = (params: ListarClavesSatClavesCuentaParams = {}) =>
  queryOptions({
    queryKey: [...qk.adminClavesSatClavesCuenta, "paginado", params] as const,
    queryFn: () => listarClavesSatClavesCuenta(params),
    placeholderData: keepPreviousData,
  });

export function useClavesSatClavesCuenta(params: ListarClavesSatClavesCuentaParams = {}) {
  return useQuery(clavesSatClavesCuentaQueryOptions(params));
}
